(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["search"] = factory();
	else
		root["OAJ"] = root["OAJ"] || {}, root["OAJ"]["search"] = factory();
})(self, () => {
return 